var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lives-wrapbox"},[_c('project-list',{attrs:{"checked-list":_vm.info.subjects}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }